import React, {createContext, useState, ReactNode, useContext, useEffect} from 'react';
import {useNavigate} from "react-router-dom";

interface LayoutContextType {
  isSidebarOpen: boolean;
  setSidebarVisibility: (isOpen: boolean) => void;
  isMobileResolution: boolean;
  isTouchDevice: boolean;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [isMobileResolution, setIsMobileResolution] = useState(false);

  const [isTouchDevice, setIsTouchDevice] = useState(window.matchMedia("(pointer: coarse)").matches);
  const setSidebarVisibility = (isOpen: boolean) => {
    setIsSidebarOpen(isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsMobileResolution(true);
      } else {
        setIsMobileResolution(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    if(window.matchMedia("(pointer: coarse)").matches) {
      setIsTouchDevice(true);
    }
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if(isMobileResolution) {
      setIsSidebarOpen(false);
    }
  }, [isMobileResolution]);

  return (
    <LayoutContext.Provider value={{ isTouchDevice, isMobileResolution, isSidebarOpen, setSidebarVisibility }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayoutContext = (): LayoutContextType => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutProvider');
  }
  return context;
};